import { AxiosResponse } from 'axios';

import AuthenticateService from '@qality/cloud-services/src/AuthenticateService';
import { Feedback } from '@qality/common-model/src/Feedback';
import { AxiosWrapperService as axios } from '@qality/common-service';

const USER_FEEDBACK_URL = `${window.location.origin}/userFeedback`;

const headers = {
  'Content-Type': 'application/json',
};

const saveRating = async (
  data: Pick<Feedback, 'rating'>
): Promise<AxiosResponse<Feedback['id']>> => {
  const url = await AuthenticateService.authenticateByJWT(USER_FEEDBACK_URL);

  return axios.post(url, { emojiNumber: data.rating }, { headers });
};

const saveComment = async (
  data: Pick<Feedback, 'id' | 'comment'>
): Promise<void> => {
  const { id, comment } = data;

  const url = await AuthenticateService.authenticateByJWT(
    `${USER_FEEDBACK_URL}/${id}`
  );

  axios.put(url, { comment }, { headers });
};

export default { saveRating, saveComment };
